import { useQuery, useMutation, useQueryClient } from "react-query";
import apiRoutes from "../../api/apiRoutes";
import ApiCall from "../../api/network";
import { toast } from "react-hot-toast";

// get profile
const fetchUserProfile = async () => {
  return await ApiCall.any(apiRoutes.getUserProfile);
};


const fetchTravelStyleWithDestinations = async () => {
    return await ApiCall.any(apiRoutes.getTravelStyleWithDestinations);
}
export const useFetchUserProfile = (options = {}) => {
  return useQuery("userProfile", () => fetchUserProfile(),{
    staleTime: 60 * (60 * 1000),
    ...options,
  });
};

//update avatar

const updateAvatar = async (data) => {
  return await ApiCall.any(apiRoutes.updateAvatar, {}, data);
};

export const useAvatarUpdate = (setImage) => {
  const queryClient = useQueryClient();
  return useMutation(updateAvatar, {
    onSuccess: (data) => {
      setImage({
        image: "",
        displayImage: "",
      });
      if (data.status === 1) {
        queryClient.refetchQueries("userProfile");
        toast.success("Avatar Updated Successfully");
      }
    },
    onError: (_error, context) => {
      queryClient.setQueriesData("userProfile", context.previousData);
    },
  });
};

//update profile

const updateProfile = async (data) => {
  return await ApiCall.any(apiRoutes.updateProfile, {}, data);
};

export const useProfileUpdate = (setEdit) => {
  const queryClient = useQueryClient();
  return useMutation(updateProfile, {
    onSuccess: (data) => {
      if (data.status === 1) {
        setEdit(false);
        queryClient.refetchQueries("userProfile");
        toast.success("Profile Updated Successfully");
      }
    },
    onError: (_error, context) => {
      queryClient.setQueriesData("userProfile", context.previousData);
    },
  });
};

//update avatar

const updateAccount = async (data) => {
  return await ApiCall.any(apiRoutes.updatePassword, {}, data);
};

export const useUpdateAccount = (deleteCookie) => {
  const queryClient = useQueryClient();
  return useMutation(updateAccount, {
    onSuccess: (data) => {
      if (data.status === 1) {
        queryClient.refetchQueries("userProfile");
        toast.success("Password Updated Successfully, Login Again");
        //deleteCookie && deleteCookie();
      }
    },
    onError: (_error, context) => {
      queryClient.setQueriesData("userProfile", context.previousData);
    },
  });
};
//update tax region

const updateTaxRegion = async (data) => {

    const updateUserTaxRegion = {
        url : '/update/user-tax-region',
        method: "POST",
        useAuth: true,
    }
  return await ApiCall.any(updateUserTaxRegion, {}, data);
};

export const useUpdateTaxRegion = (refetch) => {
  const queryClient = useQueryClient();
  return useMutation(updateTaxRegion, {
    onSuccess: (data) => {
      if (data.status === 1) {
        toast.success("Region Updated Successfully. Please proceed to payment")
          refetch()
      }
    },
    onError: (_error, context) => {
        toast.error("Something went wrong!");
    },
  });
};
